import React from "react";

const Resume = ({ data }) => {
  if (data) {
    var skillmessage = data.skillmessage;
    var education = data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3>{education.school}</h3>
          <p className="info">
            {education.degree} <span>&bull;</span>
            <em className="date">{education.graduated}</em>
          </p>
          <p>{education.description}</p>
        </div>
      );
    });
    var work = data.work.map(function (work) {
      return (
        <div key={work.title + "-" + work.company}>
          <h3>{work.company}</h3>
          <p className="info">
            {work.title}
            <span>&bull;</span> <em className="date">{work.years}</em>
          </p>
          {Array.isArray(work.description) ? (
            <ul className="work-bullets">
              {work.description.map(function (bullet) {
                return <li key={bullet}>{bullet}</li>;
              })}
            </ul>
          ) : (
            <p>{work.description}</p>
          )}
        </div>
      );
    });
    var skills = data.skills.map(function (skillGroup) {
      var tiles = skillGroup.items.map(function (skill) {
        return (
          <li key={skill.name} className="skill-tile">
            {skill.icon ? (
              <img src={"images/skills/" + skill.icon} alt={skill.name} />
            ) : (
              <span className="skill-tile-fallback">
                {skill.name.charAt(0)}
              </span>
            )}
            <em>{skill.name}</em>
          </li>
        );
      });
      return (
        <div key={skillGroup.category}>
          <h3>{skillGroup.category}</h3>
          <ul className="skill-tiles">{tiles}</ul>
        </div>
      );
    });
  }

  return (
    <section id="resume">
      <div className="row education">
        <div className="three columns header-col">
          <h1>
            <span>Education</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="row item">
            <div className="twelve columns">{education}</div>
          </div>
        </div>
      </div>

      <div className="row work">
        <div className="three columns header-col">
          <h1>
            <span>Work</span>
          </h1>
        </div>

        <div className="nine columns main-col">{work}</div>
      </div>

      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <span>Skills</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <p>{skillmessage}</p>

          {skills}
        </div>
      </div>
    </section>
  );
};

export default Resume;
